import ISceneObject from "../model/sceneObject/ISceneObject";
import SceneObjectTypeEnum from "../model/sceneObjectData/SceneObjectTypeEnum";
import LengthDimensionData from "../model/sceneObjectData/LengthDimensionData";
import TextAnnotationData from "../model/sceneObjectData/TextAnnotationData";
import AreaAnnotationData from "../model/sceneObjectData/AreaAnnotationData";
import RectangleAnnotationData from "../model/sceneObjectData/RectangleAnnotationData";
import CircleAnnotationData from "../model/sceneObjectData/CircleAnnotationData";

export interface SceneObjectSummary {
    labelKey: string;
    value?: string;
    color: string;
}

const VALUE_PREVIEW_MAX_LENGTH = 30;
const DEFAULT_COLOR = '#8a94a6';

function truncate(text: string, maxLength: number): string {
    return text.length > maxLength ? `${text.slice(0, maxLength - 1)}…` : text;
}

// Short label/value/swatch shown on the selection context toolbar. Not part of the property
// system — just enough of a per-type preview to identify what's selected at a glance.
export function getSceneObjectSummary(sceneObject: ISceneObject): SceneObjectSummary {
    switch (sceneObject.data.type) {
        case SceneObjectTypeEnum.LengthDimension:
            return {
                labelKey: 'ui.selectionToolbar.type.lengthDimension',
                value: (sceneObject.data as LengthDimensionData).text || undefined,
                color: '#6b8fd6',
            };
        case SceneObjectTypeEnum.TextAnnotation:
            return {
                labelKey: 'ui.selectionToolbar.type.textAnnotation',
                value: truncate((sceneObject.data as TextAnnotationData).text, VALUE_PREVIEW_MAX_LENGTH) || undefined,
                color: '#5eead4',
            };
        case SceneObjectTypeEnum.AreaAnnotation:
            return {
                labelKey: 'ui.selectionToolbar.type.areaAnnotation',
                value: `${(sceneObject.data as AreaAnnotationData).computeEnclosedArea().toFixed(1)} m²`,
                color: '#e2b25b',
            };
        case SceneObjectTypeEnum.RectangleAnnotation:
            return {
                labelKey: 'ui.selectionToolbar.type.rectangleAnnotation',
                value: `${(sceneObject.data as RectangleAnnotationData).computeEnclosedArea().toFixed(1)} m²`,
                color: '#e2b25b',
            };
        case SceneObjectTypeEnum.CircleAnnotation:
            return {
                labelKey: 'ui.selectionToolbar.type.circleAnnotation',
                value: `${(sceneObject.data as CircleAnnotationData).computeEnclosedArea().toFixed(1)} m²`,
                color: '#e2b25b',
            };
        case SceneObjectTypeEnum.ChecklistItem:
            return { labelKey: 'ui.selectionToolbar.type.checklistItem', color: '#a78bfa' };
        default:
            return { labelKey: 'ui.selectionToolbar.type.object', color: DEFAULT_COLOR };
    }
}
